import * as React from 'react';
import { NavLink } from 'react-router-dom';

import Pagination from 'antd/es/pagination';
import Tag from 'antd/es/tag';

import { ItemsProvider, useItemsProviderContext, SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';

import { GlobalProcedure } from '@commonTuna/react/objects/GlobalProcedure';

import '@app/scss/pages/catalog.scss';

const ProcedureList: React.FC = () => {
	const { state: { items, pagination }, actions: { handleChange } } = useItemsProviderContext<GlobalProcedure>();

	const onPaginationChange = (current, pageSize) => {
		handleChange({ page: current, pageSize });
	};

	return (<div className="catalog mb10">
		<ul className="catalog__list">
			{items.map((item) => <li key={item.id} className="catalog__list__item">
				{item.path ? <NavLink to={`/procedures/${item.path}`}>
					<Tag color="purple">
						{item.name}
					</Tag>
				</NavLink>
					: <Tag color="purple">
						{item.name}
					</Tag>}
			</li>)}
		</ul>
		{pagination?.total > items.length && <div className="pull-right mt10 mb10">
			<Pagination onChange={onPaginationChange} {...pagination} />
		</div>}
	</div>);
};

const Procedures: React.FC = () => {
	return <>
		<ServerPageProvider
			path="procedures"
			defaultTitle="Procedures"
			inner={(page) => (
				<ItemsProvider<GlobalProcedure>
					rows={page?.items}
					loadRequest="GlobalProcedurePortalListRemote"
					filters={{ column: [{ caption: 'name', direction: SortingDirection.Ascending }] }}
					paginationUrl={{ defaultPageSize: 200 }}
					withHandleUrl
				>
					<div className="container">
						<BreadCrumbs
							title="Procedures"
						/>
						<div className="site-headline site-headline_with-button clearfix">
							<h1 className="pull-left">Procedures</h1>
						</div>
						<ProcedureList />
					</div>
				</ItemsProvider>
			)}
		/>
	</>;
};

export default Procedures;
